import { emptyPagedCollection, IPagingData, WccDto, WccPermissions } from '@sr/dto';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { wccListApi } from './api';
import { useUserAuth } from 'features/auth';

export const useWccList = (paging: IPagingData, filterString?: string, type?: 'client' | 'supplier') => {
  const { user } = useUserAuth();
  let filter = filterString;
  if (type) {
    filter += `&type=${type}`;
  }
  if (user?.permissions.some((permission) => permission === WccPermissions.VIEW_ANY || permission === WccPermissions.CREATE_EDIT)) {
    filter += '&showAll=true';
  }
  const { data, isLoading, error } = wccListApi.useGetWccListQuery({ paging, filter }, { refetchOnMountOrArgChange: true });

  const result: Omit<IRemotePagedCollection<WccDto>, 'reload'> = {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return result;
};


export const useDeleteWcc = () => {
  const [_deleteByInvoiceId] = wccListApi.useDeleteWccByInvoceIdMutation();
  const [delById] = wccListApi.useDeleteWccMutation();


  return {
    deleteByInvoiceId: (invoiceId: number) => {
      return _deleteByInvoiceId(invoiceId).unwrap();
    },
    deleteById: (id: number) => {
      return delById(id).unwrap();
    }
  };
};

